export const AUDIT_QUESTIONS = [
    {
        text: 'Do you know what percentage of the referrals you sent out last month actually resulted in a completed visit?',
        options: [
            { label: 'Yes, I track this exactly', points: 3 },
            { label: 'I have a rough estimate', points: 1 },
            { label: 'No idea', points: 0 },
        ],
    },
    {
        text: 'When you send a referral, how long does it typically take before you know it was received?',
        options: [
            { label: 'Same day', points: 3 },
            { label: 'A few days', points: 1 },
            { label: "I usually don't find out unless I call", points: 0 },
        ],
    },
    {
        text: 'If a referral stalls, who notices first?',
        options: [
            { label: 'Our system flags it automatically', points: 3 },
            { label: 'A staff member happens to check', points: 1 },
            { label: 'The patient calls asking what happened', points: 0 },
        ],
    },
    {
        text: 'How many different channels (fax, portal, phone, email) does your practice use to send referrals?',
        options: [
            { label: '1', points: 3 },
            { label: '2–3', points: 1 },
            { label: '4+', points: 0 },
        ],
    },
    {
        text: 'Is there a written record of every follow-up attempt on a stuck referral?',
        options: [
            { label: 'Yes, logged automatically', points: 3 },
            { label: 'Sometimes, in notes or a spreadsheet', points: 1 },
            { label: "No — it's in people's memory", points: 0 },
        ],
    },
    {
        text: 'If a patient asks "what happened to my referral," how fast can you answer?',
        options: [
            { label: 'Under a minute', points: 3 },
            { label: 'A few minutes of digging', points: 1 },
            { label: "I'd have to call the other office to find out", points: 0 },
        ],
    },
    {
        text: 'Do you know how many referrals from last month are still unresolved right now?',
        options: [
            { label: 'Yes, exact number', points: 3 },
            { label: 'Rough idea', points: 1 },
            { label: 'No', points: 0 },
        ],
    },
    {
        text: 'If a receiving office never responds, what happens?',
        options: [
            { label: 'Automatic escalation or resend', points: 3 },
            { label: 'Someone eventually remembers to follow up', points: 1 },
            { label: 'Usually nothing — it just sits', points: 0 },
        ],
    },
    {
        text: 'Has a patient ever told you they were never actually scheduled with the specialist you referred them to?',
        options: [
            { label: 'Never', points: 3 },
            { label: 'Rarely', points: 1 },
            { label: 'More than once', points: 0 },
        ],
    },
    {
        text: 'If someone audited your referral completion rate today, would the number surprise you?',
        options: [
            { label: "No — I track this and I'm confident in it", points: 3 },
            { label: 'Not sure', points: 1 },
            { label: 'Yes, it probably would', points: 0 },
        ],
    },
]

export const AUDIT_PARENT_ORIGINS = [
    'https://medmatchnetwork.com',
    'https://www.medmatchnetwork.com',
    'https://stage.medmatchnetwork.com',
    'http://localhost:8887',
]
